// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"630":"96bacd06","708":"9cbf5104"}[chunkId] + ".chunk.js";
};